import React, { Component } from 'react';
import { Divider, Switch, Button, Slider } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class PKSettings extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      DropItemWhenDie: true,
      MinPKLevel: 20,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          PK Settings
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '180px' }}>Drop Item when Die</td>
              <td>
                <Switch
                  checked={this.state.DropItemWhenDie}
                  {...SwitchOnOff}
                  onChange={this.handleChange('DropItemWhenDie')}
                />
              </td>
            </tr>

            <tr>
              <td>Minumum PK Level</td>
              <td style={{ width: '360px' }}>
                <Slider
                  min={20}
                  max={120}
                  labelStepSize={10}
                  onChange={this.handleChange('MinPKLevel')}
                  value={this.state.MinPKLevel}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
